module.exports = __webpack_public_path__ + "img/ic-amount-threshold.85492119.svg";